<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="part-i-sorrow-to-revenge">
<h1>Part I: Sorrow to Revenge</h1>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?9d796380